"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DeleteReviewTemplateResponse () {
        return DeleteReviewTemplateResponse;
    },
    get GetReviewTemplatesResponse () {
        return GetReviewTemplatesResponse;
    },
    get ReviewTemplateListItem () {
        return ReviewTemplateListItem;
    },
    get ReviewTemplateListItemWithDefaults () {
        return ReviewTemplateListItemWithDefaults;
    },
    get ReviewTemplateResponse () {
        return ReviewTemplateResponse;
    },
    get ReviewTemplateWithNamesAndDefaults () {
        return ReviewTemplateWithNamesAndDefaults;
    }
});
const _zod = require("zod");
const _reviewtemplatehelper = require("../helpers/review-template-helper");
const _reviewtemplates = require("./review-templates");
const ReviewTemplateListItem = _reviewtemplates.ReviewTemplate.omit({
    formAssignments: true
}).extend({
    formAssignmentsCount: _zod.z.number()
});
const ReviewTemplateWithNamesAndDefaults = _zod.z.preprocess((input)=>{
    const typedInput = input;
    const core = (0, _reviewtemplatehelper.convertTemplateModelToServiceContract)(typedInput, true);
    return (0, _reviewtemplatehelper.withParticipantNames)(typedInput, core);
}, _reviewtemplates.ReviewTemplateWithNames);
const ReviewTemplateListItemWithDefaults = _zod.z.preprocess((input)=>(0, _reviewtemplatehelper.convertTemplateModelToServiceContract)(input, false), ReviewTemplateListItem);
const GetReviewTemplatesResponse = _zod.z.object({
    data: _zod.z.array(ReviewTemplateListItem),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const ReviewTemplateResponse = _zod.z.object({
    data: _reviewtemplates.ReviewTemplateWithNames,
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const DeleteReviewTemplateResponse = _zod.z.object({
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
